import { Link } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldEvmVersion from '../fields/ContractVerificationFieldEvmVersion';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const MAIN_SOURCES_TYPES = [ '.vy' as const ];
const INTERFACE_TYPES = [ '.vy' as const, '.json' as const ];

const ContractVerificationVyperMultiPartFile = () => {
  const { t } = useI18n();

  const interfacesHint = (
    <>
      <span>{ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperInterfacesHintPart1) } </span>
      <Link href="https://docs.vyperlang.org/en/stable/interfaces.html" target="_blank">
        { t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperInterfacesHintLink) }
      </Link>
      <span> { t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperInterfacesHintPart2) }</span>
    </>
  );

  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['vyper-multi-part']) }>
      <ContractVerificationFieldCompiler isVyper/>
      <ContractVerificationFieldEvmVersion isVyper/>
      <ContractVerificationFieldSources
        name="sources"
        fileTypes={ MAIN_SOURCES_TYPES }
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperMainTitle) }
        hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperMainHint) }
        required
      />
      <ContractVerificationFieldSources
        name="interfaces"
        fileTypes={ INTERFACE_TYPES }
        multiple
        fullFilePath
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.vyperInterfacesTitle) }
        hint={ interfacesHint }
      />
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationVyperMultiPartFile);
